import React, { useState, useContext } from 'react';
import { connect } from 'react-redux';
import DatePickerReports from "../../components/DatePickerReports"
import DownloadReportsBlock from '../../components/DownloadReportsBlock/index.store'
import { AuthContext } from '../../context/AuthContext';

import BaseSelect from '../../components/BaseSelect';
import BaseForm from '../BaseForm';

import {
  updateDealer,
  updateUserEmail,
  updateUserStatus,
  updateUserRole,
  updateUserData,
  addNewUser
} from '../../store/actions';

import {
  REQUIRED,
  ALPHABETICAL,
  EMAIL,
  PHONE
} from '../../utils/formValidation';

import './index.css';
import ButtonSecondary from '../ui/ButtonSecondary';

const EmployeeDetails = (props) => {
  const {role} = useContext(AuthContext);
  const [formValues] = useState({
    UUID: props.employee.UUID,
    firstName: props.employee.firstName,
    lastName: props.employee.lastName,
    email: props.employee.email,
    phone: props.employee.phone,
    address: props.employee.address,
    zip: props.employee.zip,
  });

  const [statuses, setStatuses] = useState({
    role: props.employee.role,
    status: props.employee.status,
  })
  const [ showDatePickerEmployeesReports, setShowDatePickerEmployeesReports ] = useState(false)
  const formData = [
    {
      name: 'firstName',
      labelName: 'First Name',
      type: 'text',
      validation: [REQUIRED, ALPHABETICAL]
    },
    {
      name: 'lastName',
      labelName: 'Last Name',
      type: 'text',
      validation: [REQUIRED, ALPHABETICAL]
    },
    {
      name: 'email',
      labelName: 'Email',
      type: 'text',
      validation: [REQUIRED, EMAIL]
    },
    {
      name: 'phone',
      labelName: 'Phone',
      type: 'text',
      validation: [REQUIRED, PHONE]
    },
    {
      name: 'address',
      labelName: 'Street Address',
      type: 'text',
      validation: [REQUIRED]
    },
    {
      name: 'zip',
      labelName: 'Zip',
      type: 'text',
      validation: [REQUIRED]
    }
  ]

  const actionsData = {
    email: data => props.updateUserEmail(formValues.UUID, data.email),
    other: data => props.updateUserData(formValues.UUID, {
      firstName: data.firstName,
      lastName: data.lastName,
      phone: data.phone,
      address: data.address,
      zip: data.zip,
    }),
  }

  const updateStatus = (prop, status) => {
    props.updateUserStatus(props.employee.UUID, status);
    setStatuses({...statuses, status});
  }

  const updateRole = (prop, role) => {
    props.updateUserRole(props.employee.UUID, role);
    setStatuses({...statuses, role});
  }

  const isChangePasswordAvailable = role === 'admin' || props.employee.role === 'other' || props.employee.role === 'standard';

  const toggleDatePickerEmployeesReports = () => {
    setShowDatePickerEmployeesReports(!showDatePickerEmployeesReports)
  }

  return (
    <div className="employee-details">
      <BaseForm
        title="Employee info"
        readOnly={role !== 'admin'}
        formData={formData}
        initialData={formValues}
        actionsData={actionsData}
      >
      <div className="base-form__form-group">
        <label className="base-form__label" htmlFor="role">Role</label>
        <BaseSelect
          readOnly={role !== 'admin'}
          format="select"
          value={statuses.role}
          inputClassName="base-form__select"
          wrapperClassName="base-form__select-wrapper"
          id="role"
          name="role"
          selectOptions={{
            options: [
            'manager',
            'admin',
            'standard',
            'other'
            ],
            prop: 'role'
          }}
          selectOption={updateRole}
        />
      </div>
      <div className="base-form__form-group">
        <label className="base-form__label" htmlFor="status">Status</label>
        <BaseSelect
          readOnly={role !== 'admin'}
          format="select"
          value={statuses.status}
          inputClassName="base-form__select"
          wrapperClassName="base-form__select-wrapper"
          id="status"
          name="status"
          selectOptions={{
            options: [
            'active',
            'inactive',
            'removed',
            'other',
            ],
            prop: 'status'
          }}
          selectOption={updateStatus}
        />
      </div>
      </BaseForm>
      <DownloadReportsBlock title='Employees' toggleDatePickerReports={toggleDatePickerEmployeesReports} />
      {
        isChangePasswordAvailable &&
        <div className="form__group form__btn-group employee-details__controls">
          <ButtonSecondary
            className="btn btn--secondary"
            name="Change Password"
            onClick={props.onChangePassword}
          />
        </div>
      }

    </div>
  );
}

export default connect(null, {
  updateDealer,
  updateUserEmail,
  updateUserStatus,
  updateUserRole,
  updateUserData,
  addNewUser
})(EmployeeDetails);
